class AjaxForm {
	constructor() {
		this.formClass = ".js-ajax-form";
		this.form = false;

		this.init();
	}

	init() {
		var $this = this;

		$("body").on("submit", $this.formClass, function (e) {
			e.preventDefault();

			$this.form = $(this);

			$this.submit(this);
		});

		$this.maybeSubmitOnLoad();
	}

	dispatch(el, name, detail) {
		el.dispatchEvent(new CustomEvent(name, { detail }));
	}

	submit(form) {
		var $this = this;
		$this.dispatch(form, "ajaxstart");
		this.loadingState();

		let data;
		let fileUpload = typeof this.form.attr("data-file-upload") != "undefined";
		if (fileUpload) {
			data = new FormData(form);
		}else{
			data = this.form.serialize() 
		}

		let settings = {
			type: "POST",
			url: this.form.attr("action"),
			data: data,
			success: function (result) {
				$this.dispatch(form, "ajaxsuccess", { data: result });
				$this.dispatch(form, "ajaxend");
				$this.success(result);
			},
			error: function (data) {
				$this.dispatch(form, "ajaxerror", { data: data.responseJSON });
				$this.dispatch(form, "ajaxend");
			},
		}

		if(fileUpload){
			settings.contentType = false;
			settings.processData = false;
		}

		$.ajax(settings);
	}

	success(result) {
		var refresh_target = this.form.attr("data-refresh");

		if (typeof this.form.attr("data-refresh") != "undefined") {
			$(refresh_target).html(result);

			if (typeof this.form.attr("data-scroll") != "undefined") {
				$('html, body').scrollTop( $(refresh_target).offset().top - $('header:first').height() - 50)
			}
		}
	}

	loadingState() {
		var refresh_target = this.form.attr("data-loading");

		if (typeof this.form.attr("data-refresh") != "undefined") {
			$(refresh_target).html(
				'<div class="loading"><i class="fas fa-sync fa-spin"></i></div>'
			);
		}
	}

	maybeSubmitOnLoad() {
		$.each($(this.formClass), function () {
			if (typeof $(this).attr("data-submit-on-load") != "undefined") {
				$(this).submit();
			}
		});
	}
}

export default AjaxForm;
